import { CruiseType } from 'constants/cruise'
import { useQsQueryParams } from 'hooks/useQueryParams'

export default function useCruiseSelectedCabinType(cruiseType?: App.CruiseType) {
  const { cabinTypes } = useQsQueryParams<{ cabinTypes?: string }>()

  if (cabinTypes && cabinTypes.length > 1 && cabinTypes.includes('oceanview') && cabinTypes.includes('window')) {
    if (cruiseType && cruiseType === CruiseType.RIVER) {
      return 'window'
    } else if (cruiseType && cruiseType === CruiseType.OCEAN) {
      return 'oceanview'
    }

    return 'oceanview_window'
  }

  return cabinTypes
}
